<template>
    <div class="index">
        <div class="flash">
            <div class="gg">
                <div><div class="topNav">解决方案</div></div>
                <div class="title">汽车行业</div>
                <div class="minTitle">汽车制造行业-项目品质全面提升方案</div>
                <!-- <div class="button">咨询详情</div> -->
            </div>
        </div>
       <picture>
            <source srcset="@/assets/images/qc1_mb.jpg" media="(max-width:768px)" alt="">
            <img class="flashImg" src="@/assets/images/qc1.png" />
        </picture>
       <div class="lxwm bg1">
            <div class="content">
                <div class="title1 tc">产品特点</div>
                <div class="items mt5">
                    <div class="item2">
                        <div class="tit">
                            <img src="@/assets/images/qc2.png" />
                            <div class="lb">
                                流程执行问题
                            </div>
                        </div>
                        
                        <div class="minTitle2 mt10">·项目不能按计划执行，计划不能及时调整</div>
                        <div class="minTitle2">·单元测试和代码评审工作被忽略</div>
                        <div class="minTitle2">·测试事件被压缩，导致执行不到位</div>
                        <div class="minTitle2">·需求变更没能得到控制</div>
                    </div>
                    <div class="item2">
                        <div class="tit">
                            <img src="@/assets/images/qc3.png" />
                            <div class="lb">
                                文档品质问题
                            </div>
                        </div>
                        
                        <div class="minTitle2 mt10">·需求说明书描述不清晰、不完整</div>
                        <div class="minTitle2">·设计文档描述不正确</div>
                        <div class="minTitle2">·测试范围和目的不明确</div>
                        <div class="minTitle2">·测试用例描述不清晰，未能覆盖所有需求</div>
                    </div>
                    <div class="item2">
                        <div class="tit">
                                <img src="@/assets/images/qc4.png" />
                            <div class="lb">
                                代码品质问题
                            </div>
                        </div>
                        
                        <div class="minTitle2 mt10">·不遵循既定的代码规则</div>
                        <div class="minTitle2">·代码具有安全性隐患</div>
                        <div class="minTitle2">·使用了不妥当的数据库操作语句</div>
                    </div>
                    <div class="item2 item3">
                        <div class="tit">
                            <img src="@/assets/images/qc5.png" />
                            <div class="lb">
                                供应商的开发能力
                            </div>
                        </div>
                       
                        <div class="minTitle2 mt10">·选择供应商时的决策依据不足</div>
                        <div class="minTitle2">·供应商提供服务时水平参差不齐</div>
                        <div class="minTitle2">·供应商开发和测试过程失控</div>
                    </div>
                </div>
                <div class="ibr">
                    <div class="title1 tc mt40 mb20"> 解决方案-建立品质保证和品质控制体系</div>
                    <div class="tc">
                        <img class="conImg" src="@/assets/images/qc6.png" />
                    </div>
                </div>
            </div>
       </div>
       <div class="lxwm2 bg3">
            <div class="content">
                <div class="title1 tc">方案特点</div>
                <div class="items mt5">
                    <div class="item2">
                        <div class="tit">
                            <img src="@/assets/images/qc7.png" />
                            <div class="lb">
                                项目组能力要求
                            </div>
                        </div>
                        <div class="flex">
                            <div class="minTitle2 hs mt10">·业务能力</div>
                            <div class="minTitle2 hs">·项目管理能力</div>
                            <div class="minTitle2 hs">·技术能力</div>
                            <div class="minTitle2 hs">·沟通能力</div>
                            <div class="minTitle2 hs">·洞察能力</div>
                            <div class="minTitle2 hs">·测试能力</div>
                            <div class="minTitle2 hs">·过程能力</div>
                        </div>
                    </div>
                    <div class="item2">
                        <div class="tit">
                            <img src="@/assets/images/qc8.png" />
                            <div class="lb">
                                角色能力培养能力
                            </div>
                        </div>
                        <div class="flex">
                            <div class="minTitle2 hs mt10">·技术能力培养、提升</div>
                            <div class="minTitle2 ">技能能力培养提升</div>
                            <div class="minTitle2 hs mt5">·项目实施</div>
                            <div class="minTitle2 ">实际操作能力培养</div>
                            <div class="minTitle2 hs mt5">·过程能力培养、提升</div>
                            <div class="minTitle2 ">培训、过程、模型制作</div>
                        </div>
                    </div>
                    <div class="item2 item3">
                        <div class="tit">
                            <img src="@/assets/images/qc9.png" />
                            <div class="lb">
                                服务模型能力
                            </div>
                        </div>
                        <div class="flex">
                            <div class="minTitle2 hs mt10">·体系建立</div>
                            <div class="minTitle2 towLine">根据客户的需求和现状提供品质管理体系建设服务，包括规范建立、协助培训和推广</div>
                            <div class="minTitle2 hs mt5">·品质/工具咨询</div>
                            <div class="minTitle2 ">提供品质和工具的咨询服务</div>
                            <div class="minTitle2 hs mt5">·品质监测</div>
                            <div class="minTitle2 ">针对过程和产品的品质进行监测并提供监测报告</div>
                        </div>
                    </div>
                </div>
            </div>
       </div>
    </div>
</template>
<script>
    export default {
        components: {
        },
        data() {
            return {
                
            }
        },
        methods: {
            
        }
    }
</script>

<style lang="less" scoped>
    .index {
        .flashImg {
            width: 100%;
            height: calc(30w);
        }
        .bg3 {
            background-color: #efefef;
        }
        .lxwm {
            padding: 30px 0;
            .items {
                display: flex;
                flex-wrap: wrap;
                .item2 {
                    margin-top: 20px;
                    width: 19.49%;
                    background-color: #ffffff;
                    margin-right: 2%;
                    padding: 15px 2%;
                    min-height: 110px;
                    img {
                        height: 30px;
                        margin-right: 10px;
                    }
                    .lb {
                        display: inline-block;
                        font-size: 16px;
                        font-weight: 500;
                        line-height: 35px;
                        vertical-align: bottom;
                    }
                    .minTitle2 {
                        line-height: 20px;
                    }
                }
                .item3 {
                    margin-right: 0;
                }
            }
            .ibr {
                .title1 {
                    margin: 30px 0;
                }
            }
            .mt40 {
                margin-top: 40px;
            }
            .conImg {
                width: 95%;
                height: auto;
            }
        }
        .lxwm2 {
            padding: 30px 0;
            
            .items {
                display: flex;
                flex-wrap: wrap;
                .item2 {
                    margin-top: 20px;
                    width: 27.33%;
                    background-color: #ffffff;
                    margin-right: 3%;
                    padding: 15px 2%;
                    min-height: 110px;
                    img {
                        height: 30px;
                        margin-right: 10px;
                    }
                    .lb {
                        display: inline-block;
                        font-size: 16px;
                        font-weight: 500;
                        line-height: 35px;
                        vertical-align: bottom;
                    }
                    .minTitle2 {
                        line-height: 20px;
                    }
                    .hs {
                        color: #333333;
                    }
                    .towLine {
                        line-height: 15px;
                        margin-top: 5px;
                    }
                }
                .item3 {
                    margin-right: 0;
                    
                }
            }
        }
    }
</style>
<style lang="less" scoped>
@media (max-width: 1230px) {
  .index {
    .flash {
      position: relative;
      padding: 0 50px;
      .gg .title {
        font-size: 24px;
      }
    }
    .flashImg {
      height: 100vh;
    }
  }
}
@media (max-width: 960px) {
  .index {
    .flash {
      .gg {
        color: #fff;
        .title {
          font-size: 20px;
        }
        .minColor2 {
            color: #fff;
            border-color: #fff;
        }
        .minTitle {
          width: 100%;
          font-size: 13px;
        }
        .button {
          padding: 6px 15px;
          margin-top: 20px;
        }
      }
    }
    .lxwm,.lxwm2 {
        .title1 {
            margin-bottom: 0;
            margin-top: 0;
        }
        .myTitle {
            font-size: 14px;
            background: none;
        }
        .items {
            .item2 {
                width: 100%;
                margin-right: 0;
                padding: 15px 15px;
                .minTitle2 {
                    font-size: 14px;
                }
                .lb {
                    line-height: normal;
                }
                .tit {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    img {
                        height: 20px;
                    }
                }
            }
        }
    }
    .lxwm2.bg3 .item2 {
        .tit {
            margin-bottom: 15px;
        }
        .flex {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
        }
    }
    .lxwm2.bg3 .item2:nth-of-type(1) .minTitle2 {
        width: 33.333%;
        float: left;
        margin-top: 0;
    }
    .lxwm2.bg3 .item2:nth-of-type(2) .minTitle2 {
        width: 50%;
        float: left;
        margin-top: 0;
    }
    .lxwm2.bg3 .item2:nth-of-type(3) .minTitle2 {
        width: 100%;
        margin-bottom: 5px;
    }
  }
}
@media (max-width: 768px) {
    .index {
        .flash {
            padding: 0 15px;
            .minTitle {
                width: 50%;
                font-size: 13px;
                color: #fff;
                margin-top: 26px;
                padding-right: 20px;
                box-sizing: border-box;
            }
            .gg {
                top: 50px;
                .title {
                    font-size: 20px;
                    margin-top: 26px;
                }
                .button {
                    padding: 6px 15px;
                    margin-top: 20px;
                }
            }
            
        }
        .flashImg {
            height: 40vh;
        }
    }
}
</style>